import React from "react";
import PropTypes from "prop-types";
import ValidatedInput from "../../../commonComponents/util/ValidatedInput";
import CurrencyFormatInput from "../../../commonComponents/util/CurrencyFormatInput";

const InputCell = ({
  type = "text",
  name,
  value,
  onChange,
  required = false,
  showError = false,
  maxDate = "9999-12-31"
}) => {
  const isCurrency = type === "currency";
  const isDate = type === "date";
  const className = isDate || isCurrency ? "text-right" : "text-left";

  return (
    <td className={className}>
      {isCurrency ? (
        <div className="text-right">
          <ValidatedInput
            input={<CurrencyFormatInput />}
            label=""
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            showRequiredError={showError}
          />
        </div>
      ) : (
        <ValidatedInput
          input={<input type={isDate ? "date" : "text"} max={isDate ? maxDate : undefined} />}
          label=""
          name={name}
          value={value}
          onChange={onChange}
          required={required}
          showRequiredError={showError}
        />
      )}
    </td>
  );
};

InputCell.propTypes = {
  type: PropTypes.oneOf(["text", "date", "currency"]),
  name: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  showError: PropTypes.bool,
  maxDate: PropTypes.string
};

InputCell.defaultProps = {
  type: "text",
  required: false,
  showError: false,
  maxDate: "9999-12-31"
};

export default InputCell;



// WEBPACK FOOTER //
// ./src/components/applicationsComponents/applicationsCommon/cells/InputCell.jsx